import { IconButton, TooltipHost } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { NameIcons } from "../../../../../assets/icons";
import { OrderColumn } from "../../../../../common/enum/OrderColumn";

interface IOrdenNumeroDocumentoProps {
    enabled: boolean;
    direction?: string;
    onDirectionChange: (direction: string) => void;
}

/**
 * OrdenNumeroDocumento — control asc/desc para ordenar por Nº documento (RN-002/RN-003).
 * Deshabilitado mientras no haya un tipo de certificado seleccionado (SelectorTipoCertificado).
 */
export const OrdenNumeroDocumento: React.FC<IOrdenNumeroDocumentoProps> = ({ enabled, direction, onDirectionChange }) => {
    const { t } = useTranslation("common", { keyPrefix: "REQUEST_FILTER.FILTER" });
    const { t: tCommon } = useTranslation("common", { keyPrefix: "LIST.TOOLTIP_DESCRIPTION" });

    const isDesc = direction === OrderColumn.DESC;
    const iconName = isDesc ? NameIcons.DOWN : NameIcons.UP;

    const toggleDirection = () => {
        onDirectionChange(isDesc ? OrderColumn.ASC : OrderColumn.DESC);
    };

    return (
        <TooltipHost content={enabled ? tCommon("DOCUMENT_SORT_ALPHANUMERIC") : tCommon("DOCUMENT_SORT_DISABLED")}>
            <IconButton
                iconProps={{ iconName }}
                text={t("DOCUMENT_SORT")}
                disabled={!enabled}
                onClick={toggleDirection}
                ariaLabel={t("DOCUMENT_SORT")}
                checked={!!direction}
            />
        </TooltipHost>
    );
};
